import {User} from '@/interfaces/user';
import router from '@/router/index';

export default {
  login: (context: any, payload: string): void => {
    context.commit('setToken', payload);
    router.replace('/');
  },
  setRefreshToken: (context: any, payload: User): void => {
    context.commit('setRefreshToken', payload);
  },
  setUser: (context: any, payload: User): void => {
    context.commit('setUser', payload);
  },
  logout: async (context: any) => {
    context.commit('setToken', null);
    context.commit('setUser', null);
    context.commit('setRefreshToken', null);
    localStorage.removeItem('auth_token');
    localStorage.removeItem('refresh_token');
    await router.replace('/login');
  }
};
